import React from "react";
import { withFormik } from "formik";

import { Modal } from "../../../../components/modal";
import { ValidatedForm } from "../../../../components";
import { type PackRequest } from "../types/state";
import validationSchemas from "../../../../utils/validationSchemas";
import { type PackTrialRequestModalProps, type PackTrialRequestModalWithFormProps } from "./types";
import { RequestOrEnableTrialForm } from "./RequestOrEnableTrialForm";
import RequestPackModalActions from "./RequestPackModalActions";
import ModalSizes from "../../../../enums/modalSizes";

import "./packRequestModal.scss";

export const PackTrialRequestModal: React.FC<PackTrialRequestModalWithFormProps> = (props) => {
  const { values, isValid, resetForm, onCancelPackRequest, onTrialRequest } = props;

  const renderModalActions = (closeModal: () => void) => {
    return (
      <RequestPackModalActions
        onSubmit={() => {
          onTrialRequest(values);
          closeModal();
        }}
        onCancel={() => {
          closePackRequestModal();
          closeModal();
        }}
        isValid={isValid}
        submitText="Start Trial"
      />
    );
  };

  const closePackRequestModal = () => {
    resetForm();
    onCancelPackRequest?.();
  };

  return (
    <Modal
      className={"pack-request-modal"}
      title="Start Pack Trial"
      open={props.isOpen}
      renderModalActions={renderModalActions}
      onCancel={closePackRequestModal}
      size={ModalSizes.tiny}
      dataTestId="request-pack-trial-modal"
    >
      <ValidatedForm formWidthComputer={16} formWidthTablet={16} {...props}>
        <RequestOrEnableTrialForm {...props} />
      </ValidatedForm>
    </Modal>
  );
};

/* istanbul ignore next */
const ConnectedComponent = withFormik<PackTrialRequestModalProps, PackRequest>({
  validationSchema: validationSchemas.packTrialRequestValidationSchema,
  validateOnMount: true,
  mapPropsToValues: (props: PackTrialRequestModalProps) => {
    return {
      packId: props.packId,
    } as PackRequest;
  },
  handleSubmit: () => {}, // NOSONAR
  enableReinitialize: true,
})(PackTrialRequestModal);

export default ConnectedComponent;
